import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/mensagem/';

class TrbMensagemService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.token = data;
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
            this.headersFile = {
                'Content-Type': 'multipart/form-data',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllMensagensReceebidasByUsuario(idCliente, idUsuario, idUsuarioContr, dataInicial, dataFinal) {
        return axios.get(API_URL + 'findAllMensagensReceebidasByUsuario?idCliente=' + idCliente + '&idUsuario=' + idUsuario + '&idUsuarioContr=' + idUsuarioContr + '&dataInicial=' + dataInicial + '&dataFinal=' + dataFinal, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllMensagensArquivadasByUsuario(idCliente, idUsuario, idUsuarioContr, dataInicial, dataFinal) {
        return axios.get(API_URL + 'findAllMensagensArquivadasByUsuario?idCliente=' + idCliente + '&idUsuario=' + idUsuario + '&idUsuarioContr=' + idUsuarioContr+ '&dataInicial=' + dataInicial + '&dataFinal=' + dataFinal, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllMensagensEnviadasByUsuario(idCliente, idUsuario, idUsuarioContr, dataInicial, dataFinal) {
        return axios.get(API_URL + 'findAllMensagensEnviadasByUsuario?idCliente=' + idCliente + '&idUsuario=' + idUsuario + '&idUsuarioContr=' + idUsuarioContr+ '&dataInicial=' + dataInicial + '&dataFinal=' + dataFinal, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllTiposMensagem(idCliente) {
        return axios.get(API_URL + 'findAllTiposMensagem?idCliente=' + idCliente, { headers: this.headers }).then(response => (this.data = response.data));
    }

    findAllAnexos(idMensagem) {
        return axios.get(API_URL + 'findAllAnexos?idMensagem=' + idMensagem, { headers: this.headers }).then(response => (this.data = response.data));
    }

    getAnexo(arquivo) {
        return axios({
          url: API_URL + "exportAnexo?idAnexo="+arquivo.id,
          method: "POST",
          responseType: "blob",
          data: null,
          headers: {
            'Content-Type':'application/json',
            'authorization':'Bearer ' + (this.token ? this.token.token:'')
          }
        }).then(response => {
          var fileURL = window.URL.createObjectURL(
            new Blob([response.data], { type: arquivo.tipoArquivo })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          console.log(response);
          fileLink.setAttribute("download", arquivo.nomeArquivo);
          document.body.appendChild(fileLink);
          fileLink.click();
        });
      }

    save(mensagem, idCliente) {
        return axios.post(API_URL + 'saveMensagem?idCliente=' + idCliente, JSON.stringify(mensagem),
            { headers: this.headers });
    }

    saveMensagemAnexo(idCliente, mensagemAnexo){
        return axios.post(API_URL + 'saveMensagemAnexo?idCliente=' + idCliente, JSON.stringify(mensagemAnexo),
        {headers: this.headers});
    }

    saveResposta(idUserRemetente,idMensagem, resposta, file) {
        var formData = new FormData();
        if(file != null){
            formData.append('file', file, file.name)
        }else{
            formData = null;
        }
        
        return axios.post(API_URL + 'saveMensagemResposta?idMensagem=' + idMensagem+'&idUserRemetente=' + idUserRemetente + '&resposta='+resposta, formData != null ? formData : null,
            { headers: this.headers });
    }

    saveAnexo(idMensagem, file) {
        const formData = new FormData()
        formData.append('file', file, file.name)
        return axios.post(API_URL+'saveAnexo?idMensagem='+idMensagem, formData, { headers: this.headersFile });
    }

    saveLida(idMensagem) {
        return axios.post(API_URL + 'saveLida?idMensagem=' + idMensagem, null,
            { headers: this.headers });
    }

    saveArquivada(idMensagem, opcao) {
        return axios.post(API_URL + 'saveArquivada?idMensagem=' + idMensagem + '&opcao=' + opcao, null,
            { headers: this.headers });
    }

    findAllEmailAdmin(idCliente) {
        return axios.get(API_URL + 'findAllEmailAdmin?idCliente=' + idCliente, { headers: this.headers }).then(response => (this.data = response.data));
    }

    saveAllEmailAdmin(idCliente, lista) {
        return axios.post(API_URL + 'saveAllEmailAdmin?idCliente=' + idCliente + '&lista=' + lista, null,
            { headers: this.headers });
    }

}

export default new TrbMensagemService();